import localforage from "localforage";
import { ClinicaStorageUtil } from "./utils/clinica_storage_util";

const draftStore = localforage.createInstance({
  name: "clinica-storage",
  storeName: "drafts",
});

// In-memory cache for sync reads
const draftCache = {};

/**
 * Hydrate draft cache from IndexedDB.
 * Call once before app render (alongside ClinicaStorageUtil.init).
 */
export async function initDraftCache() {
  const keys = await draftStore.keys();
  for (const key of keys) {
    draftCache[key] = await draftStore.getItem(key);
  }
}

export function resolveStorageKen(app = {}) {
  return app?.KEN || app?.iotData?.key || ClinicaStorageUtil.getLegacyKEN() || null;
}

export function getDraftStorageKey(formName, app = {}) {
  const ken = resolveStorageKen(app);
  return ken ? `${formName}-${ken}` : null;
}

export function loadDraft(formName, app = {}) {
  const key = getDraftStorageKey(formName, app);
  if (!key) return null;
  return draftCache[key] ?? null;
}

export function saveDraft(formName, app = {}, draft) {
  const key = getDraftStorageKey(formName, app);
  if (!key) return false;

  draftCache[key] = draft;
  draftStore.setItem(key, draft).catch((e) =>
    console.warn(`[DraftStorage] Failed to persist "${key}"`, e)
  );
  return true;
}

export function clearDraft(formName, app = {}) {
  const key = getDraftStorageKey(formName, app);
  if (!key) return;

  delete draftCache[key];
  draftStore.removeItem(key).catch((e) =>
    console.warn(`[DraftStorage] Failed to remove "${key}"`, e)
  );
}
